import styled from "styled-components";

export const TitleWrapper = styled.header`
  width: 100%;
  margin-bottom: 20px;
  
  h1 {
    font-weight: bold;

    &#tituloCentralizado {
      text-align: center;
    }
  }
`;